// extracted by mini-css-extract-plugin
module.exports = {"stickyHeader":"Profile_stickyHeader__mfuAW","showShadow":"Profile_showShadow__13BIC","navigationSection":"Profile_navigationSection__vU1Lj"};